import { typeUtils, type ValidatedKey } from '@festina-life/core'
import { FormikSelect } from '@festina-life/ui/formikForms'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'
import { useField } from 'formik'

import { LifeInput } from '../../inputs/LifeInput'
import {
  type AmendEmployerAgreementPolicyActionOptionTypes,
  AmendEmployerAgreementPolicyKeyToType,
  type AmendEmployerAgreementPolicySelection,
} from './amendEmployerAgreementPoliciesUtility'

type Props = {
  fieldNamePrefix: ValidatedKey
}

const actionOptions: AmendEmployerAgreementPolicyActionOptionTypes[] =
  Object.values(AmendEmployerAgreementPolicyKeyToType)

export const AmendEmployerAgreementPolicyFields = ({
  fieldNamePrefix,
}: Props) => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()

  const validateKey =
    typeUtils.createNestedValidator<AmendEmployerAgreementPolicySelection>(
      fieldNamePrefix,
    )
  const [{ value: actionOption }] = useField(validateKey('_type'))

  return (
    <>
      <FormikSelect
        name={validateKey('_type')}
        label={translate('amendEmployerAgreementPoliciesForm.actionOption')}
        options={actionOptions}
        renderFn={(actionOption) =>
          translateEnum('enum.ActionOption', actionOption)
        }
        hasRightColumnAlways
      />
      <LifeInput
        fallbackInputType="string"
        label={translate(
          'amendEmployerAgreementPoliciesForm.subTemplateIdentifier',
        )}
        name={validateKey('subTemplateIdentifier')}
      />
      {actionOption &&
        actionOption !==
          AmendEmployerAgreementPolicyKeyToType.deleteEmployerAgreementPolicy && (
          <>
            <LifeInput
              fallbackInputType="boolean"
              name={validateKey(
                'changeEmployerAgreementPolicyData.adjustSalaryFromContribution',
              )}
              label={translate(
                'amendEmployerAgreementPoliciesForm.adjustSalaryFromContribution',
              )}
            />
            <LifeInput
              fallbackInputType="boolean"
              name={validateKey(
                'changeEmployerAgreementPolicyData.policyDefaultSelected',
              )}
              label={translate(
                'amendEmployerAgreementPoliciesForm.policyDefaultSelected',
              )}
            />
          </>
        )}
    </>
  )
}
